import { render, staticRenderFns } from "./PopupConfirm.vue?vue&type=template&id=f89961ec&scoped=true&"
import script from "./PopupConfirm.vue?vue&type=script&lang=ts&"
export * from "./PopupConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./PopupConfirm.vue?vue&type=style&index=0&id=f89961ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89961ec",
  null
  
)

export default component.exports